export default "__VITE_ASSET__W8qfRxAx__"